import { Component, OnInit } from '@angular/core';

import { IonRouterOutlet, Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { LangService } from '@shared/services/lang.service';
import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar, Style } from '@capacitor/status-bar';
import { TokenStorageService } from '@auth/services/token-storage.service';
import { environment } from '@env/environment';
import { AppUpdateService } from '@shared/services/app-update.service';
import { LocalizationService } from './newapp/core/services/localization.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(
    private platform: Platform,
    private translate: TranslateService,
    private tokenStorage: TokenStorageService,
    private appUpdateService: AppUpdateService
  ) {

  }

  async ngOnInit() {
    await this.platform.ready();

    console.log('Detected Locale ', LocalizationService.DEFAULT_LOCALE);
    console.log('Detected Locale Date Format', LocalizationService.DEFAULT_DATETIME_FORMAT);
    console.log('Detected Country', LocalizationService.DEFAULT_COUNTRY_CODE, LocalizationService.DEFAULT_COUNTRY_CODE_ISO3, LocalizationService.DEFAULT_COUNTRY_CALLING_CODE);

    this.appUpdateService.init();
  }

  getRouteClass(outlet: IonRouterOutlet) {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData.pageClass;
  }

}
